import React from 'react'
import moment from 'moment-timezone'
import { Modal } from 'react-bootstrap'
import { Button } from '@abroad/components'

const ConflictWarningModal = ({
  show = false,
  handleClose = () => {},
  onContinue = () => {},
  conflictCount = 0,
  date = null,
}) => {
  const handleContinue = () => {
    onContinue()
    handleClose()
  }

  const formatDate = (dateStr) => {
    if (!dateStr) return 'this date'
    try {
      const dateMoment = moment(dateStr)
      if (dateMoment.isValid()) {
        return dateMoment.format('MMMM D, YYYY')
      }
    } catch (error) {
      console.error('Error formatting date:', error)
    }
    return 'this date'
  }

  const formattedDate = formatDate(date)

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size='lg'
      className='payment-modal'
      dialogClassName='payment-modal-dialog justify-content-center'
      backdrop={true}
      style={{ zIndex: 1060 }}>
      <Modal.Header className='payment-modal-header d-flex justify-content-center'>
        <h3 className='payment-modal-title mb-0 text-uppercase'>
          Scheduling Conflict
        </h3>
      </Modal.Header>
      <Modal.Body className='payment-modal-body'>
        <div className='sa4 font-15px text-center'>
          You have {conflictCount} scheduled session
          {conflictCount !== 1 ? 's' : ''} on <strong>{formattedDate}</strong>.
          Please reschedule {conflictCount !== 1 ? 'them' : 'it'} before making
          this date unavailable.
        </div>
      </Modal.Body>
      <Modal.Footer className='border-0 d-flex justify-content-end gap-3 flex-row'>
        <Button
          variant='secondary-light'
          className='px-4 text-uppercase secondary-popup-button'
          size='sm'
          onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant='saffron'
          className='px-4 text-uppercase'
          size='sm'
          onClick={handleContinue}>
          Continue
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ConflictWarningModal
